export default __webpack_public_path__ + "static/media/residents-tab.5cf524d0.png";